import { AfterViewInit, Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { GridCell } from '../../models/sections-model';


@Directive({
  selector: '[kwLayoutHelper]'
})
export class LayoutHelperDirective implements AfterViewInit{
  @Input()gridCell:GridCell;
  @Input() layoutClass:string;
  
  constructor(private el:ElementRef<HTMLElement>) { }

  ngAfterViewInit(): void {
    if(this.layoutClass != undefined){
      console.log(this.layoutClass);
      switch (this.layoutClass) {
        case "cell-4-2-3":
          //console.log(this.el.nativeElement.lastElementChild);
          //console.log(this.el.nativeElement.querySelector("nth-child(4)"))
          let spanChild = <HTMLElement>this.el.nativeElement.lastElementChild;
          if(spanChild != undefined){
            console.log(spanChild);
            spanChild.style.gridColumn = "1 / span 3"
          }
          break;
      
        default:
          break;
      }
    }
  }
  


}
